import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {PreferenciaHomeService} from '../services/preferencia-home.service';
import {ConstantsService} from '../fidelidade/ConstantsService';
import {AutorizacaoService} from '../services/autorizacao.service';

/**
 * O que abre em `/admin/index`.
 *
 * A rota continua sendo `/admin/index` para todo mundo — menu "Início", logo,
 * redirect do login, guards e os outros pontos que apontam para lá seguem
 * valendo sem alteração. Quem decide qual das duas homes aparece é a escolha
 * guardada no navegador, e ela vale na hora: o convite da home antiga e o
 * "voltar" da faixa de prévia trocam a tela sem recarregar nem mudar a URL.
 * Loja em onboarding guiado (conta criada pela Mia Gestor) vai para os primeiros passos.
 *
 * No celular (fora da extensão) abre a home pensada para o dono sem computador.
 * "Ver a página inicial completa" volta para a home de sempre até o fim da sessão.
 */
@Component({
  selector: 'app-home-switch',
  template: `
    <app-evolucao-loja></app-evolucao-loja>
    <app-home-celular *ngIf="usarHomeCelular" (verHomeCompleta)="mostreHomeCompleta()"></app-home-celular>
    <ng-container *ngIf="!usarHomeCelular">
      <app-home-v2 *ngIf="usarHomeNova"></app-home-v2>
      <app-home *ngIf="!usarHomeNova"></app-home>
    </ng-container>
  `
})
export class HomeSwitchComponent implements OnInit, OnDestroy {
  usarHomeNova = false;
  usarHomeCelular = HomeSwitchComponent.calculeHomeCelular();

  private static readonly CHAVE_HOME_COMPLETA = 'promokit.home.celular.completa';

  private inscricao: Subscription;
  private inscricaoEmpresa: Subscription;

  constructor(private preferenciaHome: PreferenciaHomeService, private constants: ConstantsService, private router: Router,
              private autorizacao: AutorizacaoService) {}

  ngOnInit() {
    this.inscricao = this.preferenciaHome.mudou.subscribe((nova: boolean) => this.usarHomeNova = nova);
    this.inscricaoEmpresa = this.constants.empresa$.subscribe((empresa: any) => {
      // os primeiros passos são configuração do dono: garçom segue no Início de sempre
      const garcom = !!(this.autorizacao.getUser() as any)?.garcom;
      if (empresa?.onboarding?.ativo && !garcom) this.router.navigateByUrl('/admin/comecar', {replaceUrl: true});
    });
  }

  /** Girar o aparelho ou estreitar a janela troca a tela na hora. */
  @HostListener('window:resize')
  aoRedimensionar() {
    const usar = HomeSwitchComponent.calculeHomeCelular();
    if (usar !== this.usarHomeCelular) this.usarHomeCelular = usar;
  }

  mostreHomeCompleta() {
    try { sessionStorage.setItem(HomeSwitchComponent.CHAVE_HOME_COMPLETA, '1'); } catch (e) {}
    this.usarHomeCelular = false;
  }

  private static calculeHomeCelular(): boolean {
    if (typeof window === 'undefined') return false;

    let dentroDaExtensao = true;
    try { dentroDaExtensao = window.self !== window.top; } catch (e) {}

    let pediuCompleta = false;
    try { pediuCompleta = sessionStorage.getItem(HomeSwitchComponent.CHAVE_HOME_COMPLETA) === '1'; } catch (e) {}

    return !dentroDaExtensao && !pediuCompleta && window.matchMedia('(max-width: 767.98px)').matches;
  }

  ngOnDestroy() {
    if (this.inscricao) this.inscricao.unsubscribe();
    if (this.inscricaoEmpresa) this.inscricaoEmpresa.unsubscribe();
  }
}
